import { registerTab } from "lib/@components/tabs"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Guidance } from "routes/schedule/plugins/guidance-tab/guidance"

registerTab({
    tab: "ScheduleRightBar",
    id: "Guidance",
    title: "References",
    predicate(context) {
        return context.target.legislation?.length || context.editMode
    },
    content: <Guidance $lazy priority={30} />,
})

export function useLegislationFromId(id) {
    const { legislation } = useBoundContext()
    return legislation.find((l) => l.ScheduleLegislationID.toString() === id.toString())
}
